<template class="main">
  <div class="wrap">
    <Layout class="pull-left" style="height: 100%;">
      <Sider class="nav-bar pull-left" :width="80">
        <!-- <img :src="logo" width="120" alt="" /> -->
        <div class="nav-logo">
          <img src="/static/images/logo.png" alt="" />
        </div>
        <hr class="map-list-hr" />
        <Menu active-name="1-2" theme="dark" width="auto">
          <router-link
            :key="nav.type"
            v-for="nav in navTopList"
            :to="nav.router"
          >
            <MenuItem
              :name="nav.name"
              :class="{
                'ivu-menu-item-active ivu-menu-item-selected':
                  curPath === nav.router
              }"
            >
              <img :src="nav.img" />
              <span class="text">{{ nav.name }}</span>
            </MenuItem>
          </router-link>
        </Menu>
        <div class="user-info" v-show="showLoginOut">
          <img class="head-icon" src="../../static/images/head.png" />
          <div class="user-name">{{ nickName }}</div>
          <img
            class="signout-icon"
            src="../../static/images/signout.png"
            @click="clickQuit"
          />
        </div>
      </Sider>
    </Layout>
    <Content></Content>
  </div>
</template>

<script>
import Content from "./Content.vue";
import "../assets/stylesheets/main.scss";

export default {
  data() {
    return {
      curPath: this.$route.path,
      nickName: "用户",
      showLoginOut: false
    };
  },
  components: {
    Content
  },
  computed: {
    logo() {
      return "../../static/images/logo2.png";
    },
    navTopList() {
      let path = this.$route.path;
      if (path === "/yonghui-test") {
        //永辉送货展示界面
        return [
          {
            name: "日程管理",
            router: "/yonghui-test",
            className: "nav-command",
            type: "competion"
          }
        ];
      } else if (path === "/competion") {
        //联合利华竞赛界面
        return [
          {
            name: "日程管理",
            router: "/competion",
            className: "nav-command",
            type: "competion"
          }
        ];
      } else {
        return [
          {
            name: "排班规划",
            img: "../../static/images/personnel_icon.png",
            router: "/field-map",
            className: "nav-command",
            type: "field-map"
          },
          {
            name: "我的团队",
            img: "../../static/images/user_group.png",
            router: "/field-team",
            className: "nav-watch",
            type: "field-team"
          },
          {
            name: "我的客户",
            img: "../../static//images/user_icon.png",
            router: "/field-upload",
            className: "nav-watch",
            type: "field-upload"
          },
          {
            name: "参数设置",
            img: "../../static/images/management_icon.png",
            router: "/field-set",
            className: "nav-command",
            type: "field-set"
          },
          {
            name: "规划全览",
            img: "../../static/images/point_icon.png",
            router: "/field-show",
            className: "nav-command",
            type: "field-show"
          }
        ];
      }
    }
  },
  mounted() {
    const nickname = sessionStorage.getItem("nickname");
    if (nickname) {
      //排班线上产品
      this.showLoginOut = true;
      this.nickName = nickname;
    }
  },
  methods: {
    getCurPath() {
      this.curPath = this.$route.path;
    },
    clickQuit() {
      sessionStorage.clear();
      this.$router.replace({ path: "/" });
    }
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: "getCurPath"
  },
  mounted() {}
};
</script>
<style scoped lang="less">
* {
  padding: 0;
  margin: 0;
}
#wrap {
  width: 100%;
  height: 100%;
}
.nav-logo {
  line-height: 40px;
  font-size: 20px;
  color: #fff;
  margin-top: 10px;
  img {
    width: 80%;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DemoIndex.vue